import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-7c16c5f0"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  "data-test": "personal-pathway-wheel"
}
const _hoisted_2 = { class: "container" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "/home?view=MyDashboard",
  role: "button",
  class: "btn btn-default-back back-button",
  "data-test": "ppw-back-btn"
}, " My Dashboard ", -1))
const _hoisted_4 = {
  key: 0,
  class: "cms-session-wheel",
  "data-test": "ppw-wheel"
}

import { computed, ref, watchEffect } from "vue";
import SessionWheel, { CmsSessionApiModel } from "../sessions/sessions-wheel.vue";
import {
  CmsDocument,
  CmsGoalData,
  CmsPersonalPathway,
  CmsPersonalPathwayStep,
} from "../../services/cms/cms-type-definitions";
import cms from "../../services/cms/cms";
import { PersonalPathwayCompletedStepApiModel, SessionsApiModel } from "../../api-models";
import { useAxios } from "../../composables/api";
import PathwayWheelHeader from "../../components/cms/pathway-wheel-header.vue";
import LoadingPage from "../loading-page.vue";
import { settleAll } from "../../services/utilities/settle-all";


export default /*#__PURE__*/_defineComponent({
  __name: 'personal-pathway-wheel',
  props: {
    doc: {}
  },
  setup(__props: any) {

const props = __props;
const doc = ref<CmsPersonalPathway>(props.doc as CmsPersonalPathway);

const userProgress = ref<(PersonalPathwayCompletedStepApiModel | null | undefined)[]>([]);

const isReady = ref(false);

const wheelColour = computed<string>(() => {
  return doc.value.data?.goal_relationship.data?.goal_colour || "#B0BB36";
});

const currentOutcome = computed<Partial<CmsGoalData> | null>(() => {
  if (doc.value.data.goal_relationship.data) {
    return doc.value.data.goal_relationship.data;
  }
  return null;
});

watchEffect(async () => {
  const stepProgress = doc.value.data.pathway_steps.map(
    () => undefined as PersonalPathwayCompletedStepApiModel | null | undefined,
  );

  const progressPromises: Promise<PersonalPathwayCompletedStepApiModel>[] = [];

  doc.value.data.pathway_steps.forEach((step) => {
    const { promise } = useAxios<PersonalPathwayCompletedStepApiModel>(
      `/api/personalcompletedpathwaystep?cmsStepId=${step.pathway_step.id}&cmsPathwayId=${doc.value.id}`,
    );
    progressPromises.push(promise);
  });
  settleAll(progressPromises).then((pp) => {
    pp.forEach((p, index) => {
      stepProgress[index] = p.value;
    });
    userProgress.value = stepProgress;
    isReady.value = true;
  });
});

const model = computed<SessionsApiModel | null>(() => {
  if (!userProgress.value || !userProgress.value?.every((p) => p !== undefined)) {
    return null;
  }

  const sessions = doc.value.data.pathway_steps.map((step, index): CmsSessionApiModel => {
    const pathwayStep: CmsPersonalPathwayStep = step.pathway_step as any;
    const isCompleted = !!userProgress.value[index];

    return {
      id: pathwayStep.id,
      index,
      shortTitle: cms.asText(pathwayStep.data?.tile_title) || cms.asText(pathwayStep.data.title),
      fullTitle: cms.asText(pathwayStep.data.title),
      availableDescription: [],
      unavailableDescription: [],
      theme: "team-theme",
      availableDescriptionFromCms: step.step_description,
      unavailableDescriptionFromCms: step.step_description,
      durationDescription: "",
      callToAction: "",
      isAvailable: true,
      isCompleted,
      latestSceneIndex: 0,
      imageUrl: doc.value.data?.title_image?.url || pathwayStep.data.title_image.url,
      url: cms.linkResolver(pathwayStep),
      buttonText: cms.asText(step.step_button_text) || "Go",
      itemTypeText: cms.asText(step.step_type_text) || "Step",
    };
  });
  return { sessions };
});

return (_ctx: any,_cache: any) => {
  return (doc.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createVNode(PathwayWheelHeader, { currentOutcome: currentOutcome.value }, null, 8, ["currentOutcome"])
        ]),
        (model.value && isReady.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createVNode(SessionWheel, {
                wheelColour: wheelColour.value,
                model: model.value,
                includeBackButton: true
              }, null, 8, ["wheelColour", "model"])
            ]))
          : _createCommentVNode("", true)
      ]))
    : (_openBlock(), _createBlock(LoadingPage, { key: 1 }))
}
}

})